// Styles here will override Bulma styles
import styled from '@emotion/styled';

export const StyledDetailsShort = styled.div`
  font-size: 12px;
  display: inline-block;
  align-items: center;
  margin: 0px 0 30px 0;
  color: rgba(51, 51, 51, 0.75);

  a {
    color: hsl(215, 100%, 50%);
    margin-right: 3px;
    padding-top: 3px;
  }

  a.tag,
  a.comment-count {
    margin-left: 3px;
  }
`;
